import styled from 'styled-components';
import { Button } from 'antd';

export const NetworkDashboardWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const NetworkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  padding-right: 10px;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 0 10px 4px;
`;

export const PanelTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const DrilldownIconButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: none;
  background: transparent;
  color: #8c8c8c;
  flex-shrink: 0;

  &:hover {
    color: #1890ff;
    background: rgb(24 144 255 / 10%);
  }

  .anticon {
    font-size: 14px;
  }
`;
